import React from "react";
import { SelfCheckInForm } from "../components/forms/SelfCheckInForm";

export const SelfCheckInContainer = () => {
    return <SelfCheckInForm/>;
};